exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".label {\n  width: 240px;\n  height: 80px;\n  position: absolute;\n  background-color: rgba(255, 0, 0, 1);\n  font-family: sans-serif;\n  font-size: 48px;\n  text-align: center;\n  vertical-align: middle;\n  line-height: 80px;\n  opacity: 0.8;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/css/ui/label.css
// module id = 17
// module chunks = 0